/**
 * Chain Configuration
 * Supported blockchain networks for Atlas Casino
 */

export const CHAINS = {
  1: {
    id: 1,
    name: 'Ethereum',
    shortName: 'ETH Mainnet',
    rpcUrl: 'https://eth.llamarpc.com',
    explorerUrl: 'https://etherscan.io',
    confirmations: 12,
    blockTime: 12,
    icon: '\u25C6', // diamond
  },
  8453: {
    id: 8453,
    name: 'Base',
    shortName: 'Base',
    rpcUrl: 'https://base-rpc.publicnode.com',
    explorerUrl: 'https://basescan.org',
    confirmations: 2,
    blockTime: 2,
    icon: '\u25CF', // circle
  },
};

export const DEFAULT_CHAIN_ID = 8453;
export const SUPPORTED_CHAIN_IDS = [1, 8453];

export function getChainConfig(chainId) {
  return CHAINS[chainId] || CHAINS[DEFAULT_CHAIN_ID];
}
